import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import { useSelector } from 'store';

// types
import { GuardProps } from 'types/auth';

// manager and payroll officer are read only: no edit pages, api keys or audit logs
const READ_ONLY_ROLE_PATHS: RegExp[] = [
  /\/edit\/?$/i,
  /^\/companyDetails\/DeveloperAccountSetting(\/|$)/i,
  /^\/audit-logs(\/|$)/i
];

// pages each restricted role cannot open by url; the API enforces the same rules
const RESTRICTED_PATHS: Record<string, RegExp[]> = {
  manager: READ_ONLY_ROLE_PATHS,
  payroll_officer: READ_ONLY_ROLE_PATHS
};

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn } = useAuth();
  const { role } = useSelector((state: any) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const isRestricted = isLoggedIn && (RESTRICTED_PATHS[role] || []).some((pattern) => pattern.test(location.pathname));

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
    } else if (isRestricted) {
      navigate('/dashboard', { replace: true });
    }
  }, [isLoggedIn, isRestricted, navigate, location]);

  return isRestricted ? null : children;
};

export default AuthGuard;
